module.exports = __webpack_public_path__ + "img/Dental-Store-Icon.f8010f73.png";